export default __webpack_public_path__ + "static/141-fe22510af07d5d3a9ae5f4831aac7f23.jpg";